"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultAccessTokenFetcher = exports.AccessTokenFetcher = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _BridgePlus = require("./BridgePlus");

var _helpers = require("./helpers");

var _VkError = require("./VkError");

var _const = require("./const");

var _backoff = require("./backoff");

var AccessTokenFetcher = /*#__PURE__*/function () {
  function AccessTokenFetcher() {
    (0, _classCallCheck2["default"])(this, AccessTokenFetcher);
    (0, _defineProperty2["default"])(this, "cache", {});
    (0, _defineProperty2["default"])(this, "promiseCache", {});
  }

  (0, _createClass2["default"])(AccessTokenFetcher, [{
    key: "fetch",
    value: function () {
      var _fetch = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(scope, appId, requestId) {
        var _this = this;

        var key, cachedToken, cachedPromise;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                key = "".concat(scope, "-").concat(appId);
                cachedToken = this.cache[key];

                if (!cachedToken) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", cachedToken);

              case 4:
                cachedPromise = this.promiseCache[key];

                if (!(cachedPromise !== undefined)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", cachedPromise);

              case 7:
                this.promiseCache[key] = this.getToken(scope, appId, requestId).then(function (access_token) {
                  delete _this.promiseCache[key];
                  _this.cache[key] = access_token;
                  return access_token;
                })["catch"](function (e) {
                  delete _this.promiseCache[key];
                  throw e;
                });
                return _context.abrupt("return", this.promiseCache[key]);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetch(_x, _x2, _x3) {
        return _fetch.apply(this, arguments);
      }

      return fetch;
    }()
  }, {
    key: "getToken",
    value: function () {
      var _getToken = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(scope, appId, requestId) {
        var _yield$this$fetchWith, access_token, resScope;

        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.fetchWithRetry(scope, appId, requestId);

              case 2:
                _yield$this$fetchWith = _context2.sent;
                access_token = _yield$this$fetchWith.access_token;
                resScope = _yield$this$fetchWith.scope;

                if ((0, _helpers.isGreatOrEqual)(scope, resScope)) {
                  _context2.next = 7;
                  break;
                }

                throw new _VkError.VkError("user allow not all scope request: ".concat(scope, " receive:").concat(resScope), _VkError.VkErrorTypes.ACCESS_ERROR, _const.USER_ALLOW_NOT_ALL_RIGHTS);

              case 7:
                _BridgePlus.BridgePlus.log("[".concat(requestId, "] AccessTokenFetcher receive scope: ").concat(scope, " token: ").concat((0, _helpers.trimAccessToken)(access_token)));

                return _context2.abrupt("return", access_token);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getToken(_x4, _x5, _x6) {
        return _getToken.apply(this, arguments);
      }

      return getToken;
    }()
  }, {
    key: "drop",
    value: function drop(token) {
      var _this2 = this;

      _BridgePlus.BridgePlus.log("AccessTokenFetcher drop token ".concat((0, _helpers.trimAccessToken)(token)));

      var drop = [];

      for (var key in this.cache) {
        if (this.cache.hasOwnProperty(key) && this.cache[key] === token) {
          drop.push(key);
        }
      }

      drop.forEach(function (k) {
        delete _this2.cache[k];
      });
    }
  }, {
    key: "dropAll",
    value: function dropAll() {
      this.cache = {};
    }
  }, {
    key: "fetchWithRetry",
    value: function () {
      var _fetchWithRetry = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(scope, appId) {
        var requestId,
            _args4 = arguments;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                requestId = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : '';
                _context4.next = 3;
                return (0, _backoff.exponentialBackoffForApi)( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
                  return _regenerator["default"].wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _BridgePlus.BridgePlus.log("[".concat(requestId, "] AccessTokenFetcher start fetching scope: ").concat(scope));

                          _context3.next = 3;
                          return _BridgePlus.BridgePlus.getAuthToken(scope, appId, requestId);

                        case 3:
                          return _context3.abrupt("return", _context3.sent);

                        case 4:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                })), function (e) {
                  _BridgePlus.BridgePlus.log("[".concat(requestId, "] AccessTokenFetcher failed: scope:").concat(scope), e.message, e.code, e.type);

                  if ((0, _backoff.checkIsVkError)(e)) {
                    return e.type !== _VkError.VkErrorTypes.ACCESS_ERROR;
                  }

                  return undefined;
                });

              case 3:
                return _context4.abrupt("return", _context4.sent);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function fetchWithRetry(_x7, _x8) {
        return _fetchWithRetry.apply(this, arguments);
      }

      return fetchWithRetry;
    }()
  }]);
  return AccessTokenFetcher;
}();

exports.AccessTokenFetcher = AccessTokenFetcher;
var defaultAccessTokenFetcher = new AccessTokenFetcher();
exports.defaultAccessTokenFetcher = defaultAccessTokenFetcher;